module.exports = new __parcel__URL__("80827_h.67862c1b.jpg").toString();